import { TimeDelayPickerProps } from 'shared/components/date-picker/time-delay-picker'
import { SelectedWeekDaysType } from 'shared/components/date-picker/weekdaysPicker/types'

export interface State {
  afterCampaignStepName: number | null
  chosenTimeDelay: Pick<TimeDelayPickerProps, 'selectedTimeType' | 'selectedTimeValue'>
  chosenSendingEmailTime: number | null
  chosenWeekdays: SelectedWeekDaysType
}

export enum ActionType {
  initial = 'initial',
  set_after_campaign_step_name = 'set_after_campaign_step_name',
  set_chosen_time_delay = 'set_chosen_time_delay',
  set_chosen_sending_email_time = 'set_chosen_sending_email_time',
  set_chosen_weekdays = 'set_chosen_weekdays',
}

export type Action =
  | {
      type: ActionType.initial
      payload: State
    }
  | {
      type: ActionType.set_after_campaign_step_name
      payload: State['afterCampaignStepName']
    }
  | {
      type: ActionType.set_chosen_time_delay
      payload: State['chosenTimeDelay']
    }
  | {
      type: ActionType.set_chosen_sending_email_time
      payload: State['chosenSendingEmailTime']
    }
  | {
      type: ActionType.set_chosen_weekdays
      payload: State['chosenWeekdays']
    }

export function reducer(state: State, action: Action, sideEffect: (state: State) => void): State {
  const { type, payload } = action
  if (type === ActionType.initial) {
    return { ...payload }
  }
  const setNewState = () => {
    switch (type) {
      case ActionType.set_after_campaign_step_name:
        return {
          ...state,
          afterCampaignStepName: payload,
        }
      case ActionType.set_chosen_time_delay:
        return {
          ...state,
          chosenTimeDelay: payload,
        }
      case ActionType.set_chosen_sending_email_time:
        return {
          ...state,
          chosenSendingEmailTime: payload,
        }
      case ActionType.set_chosen_weekdays:
        return {
          ...state,
          chosenWeekdays: payload,
        }
      default:
        return state
    }
  }
  const newState = setNewState()
  sideEffect(newState)
  return newState
}
